import React, { useState } from "react";
import "../assets_/style-document.css";
import {
  ArrowRight,
  Download,
  FileCopyRounded,
  FileOpen,
  FileOpenOutlined,
  FolderCopy,
  FolderCopyRounded,
  FormatListBulleted,
  InsertDriveFileRounded,
  MoreHoriz,
  MoreVert,
  TextSnippetRounded,
  Window,
} from "@mui/icons-material";
import { Grid } from "@mui/material";
import { Link } from "react-router-dom";
import { FaEye } from "react-icons/fa";

const MesDocuments = () => {
  const [activeTab, setActiveTab] = useState("grid");

  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };
  return (
    <div>
      <div className="row align-items-center mb-2">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb breadcrumb-no-gutter">
            <li class="breadcrumb-item">
              <a class="breadcrumb-link" href="javascript:;">
                Page d'acceuil
              </a>
            </li>
            <li
              class="breadcrumb-item active"
              style={{ color: "rgb(255, 77, 7)" }}
              aria-current="page"
            >
              Documents
            </li>
          </ol>
        </nav>
        <div className="col">
          <h2 className="h4 mb-0 text-dark">
            <TextSnippetRounded className="mb-2" /> Mes Documents
          </h2>
        </div>

        <div className="col-auto">
          <ul className="nav nav-segment" id="connectionsTab" role="tablist">
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${activeTab === "grid" ? "active" : ""}`}
                id="grid-tab"
                onClick={() => handleTabClick("grid")}
                role="tab"
                aria-controls="grid"
                aria-selected={activeTab === "grid"}
                title="Column view"
                style={{ cursor: "pointer" }}
              >
                <Window />
              </a>
            </li>
            <li className="nav-item" role="presentation">
              <a
                className={`nav-link ${activeTab === "list" ? "active" : ""}`}
                id="list-tab"
                onClick={() => handleTabClick("list")}
                role="tab"
                aria-controls="list"
                aria-selected={activeTab === "list"}
                title="List view"
                style={{ cursor: "pointer" }}
              >
                <FormatListBulleted />
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="tab-content">
        {activeTab === "grid" && (
          <div
            className="tab-pane fade show active"
            id="grid"
            role="tabpanel"
            aria-labelledby="grid-tab"
          >
            {/* Content for grid view */}
            <div
              className="row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4"
              data-aos="fade-out"
              data-aos-delay="50"
              data-aos-duration="900"
            >
              <div className="col col-lg-6 col-md-6 mb-3 mb-lg-5">
                {/* <!-- Card --> */}
                <div className="  cursor-pointer card card-sm card-hover-shadow card-header-borderless h-100 text-center">
                  <div className="card-header card-header-content-between border-0">
                    <span className="small">25-12-2024</span>
                    <div class="dropdown">
                      <button
                        type="button"
                        class="card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreVert />
                      </button>

                      <div
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesGridDropdown1"
                        style={{ minWidth: "13rem" }}
                      >
                        <a class="dropdown-item" href="#">
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a class="dropdown-item" href="#">
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">
                    <img
                      className="avatar avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-docs-icon.svg"
                      alt="Image Description"
                    />
                  </div>
                  <div className="card-body">
                    <h5 className="card-title text-dark">Livret de famille</h5>
                    <p className="small">Dr.Yassine Jaaidi</p>
                  </div>
                </div>

                {/* <!-- End Card --> */}
              </div>
              {/* <!-- End Col --> */}

              <div className="col col-lg-6  col-md-6  mb-3 mb-lg-5">
                {/* <!-- Card --> */}
                <div className="card  cursor-pointer card-sm card-hover-shadow card-header-borderless h-100 text-center">
                  <div className="card-header card-header-content-between border-0">
                    <span className="small">06-03-2022</span>

                    {/* <!-- Dropdown --> */}
                    <div class="dropdown">
                      <button
                        type="button"
                        class="card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreVert />
                      </button>

                      <div
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesGridDropdown1"
                        style={{ minWidth: "13rem" }}
                      >
                        <a class="dropdown-item" href="#">
                          <FileOpenOutlined className="dropdown-item-icon" />{" "}
                          Ouvrir
                        </a>
                        <a class="dropdown-item" href="#">
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>

                    {/* <!-- End Dropdown --> */}
                  </div>

                  <div className="card-body">
                    <img
                      className="avatar avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/pdf-icon.svg"
                      alt="Image Description"
                    />
                  </div>

                  <div className="card-body">
                    <h5 className="card-title text-dark">
                      Certificat médical{" "}
                    </h5>
                    <p className="small">Dr.Yassine Jaaidi</p>
                  </div>
                </div>
                {/* <!-- End Card --> */}
              </div> 
              {/* <!-- End Col --> */}

              <div className="col col-lg-6 col-md-6   mb-3 mb-lg-5">
                {/* <!-- Card --> */}
                <div className="card  cursor-pointer card-sm card-hover-shadow card-header-borderless h-100 text-center">
                  <div className="card-header card-header-content-between border-0">
                    <span className="small">05-12-2024</span>

                    {/* <!-- Dropdown --> */}
                    <div class="dropdown">
                      <button
                        type="button"
                        class="card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreVert />
                      </button>

                      <div
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesGridDropdown1"
                        style={{ minWidth: "13rem" }}
                      >
                        <a class="dropdown-item" href="#">
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a class="dropdown-item" href="#">
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>

                  <div className="card-body">
                    <img
                      className="avatar avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-slides-icon.svg"
                      alt="Image Description"
                    />
                  </div>

                  <div className="card-body">
                    <h5 className="card-title text-dark">Livret de famille</h5>
                    <p className="small">Dr.Yassine Jaaidi</p>
                  </div>
                </div>
                {/* <!-- End Card --> */}
              </div>
              {/* <!-- End Col --> */}

              <div className="col col-lg-6 mb-3 mb-lg-5">
                {/* <!-- Card --> */}
                <div className="card  cursor-pointer card-sm card-hover-shadow card-header-borderless h-100 text-center">
                  <div className="card-header card-header-content-between border-0">
                    <span className="small">25-12-2024</span>

                    {/* <!-- Dropdown --> */}
                    <div class="dropdown">
                      <button
                        type="button"
                        class="card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreVert />
                      </button>

                      <div
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesGridDropdown1"
                        style={{ minWidth: "13rem" }}
                      >
                        <a class="dropdown-item" href="#">
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a class="dropdown-item" href="#">
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>

                  <div className="card-body">
                    <img
                      className="avatar avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/pdf-icon.svg"
                      alt="Image Description"
                    />
                  </div>

                  <div className="card-body">
                    <h5 className="card-title text-dark">Livret de famille</h5>
                    <p className="small">Dr.Yassine Jaaidi</p>
                  </div>
                </div>
                {/* <!-- End Card --> */}
              </div>
              {/* <!-- End Col --> */}

              <div className="col col-lg-6  col-md-6  mb-3 mb-lg-5">
                {/* <!-- Card --> */}
                <div className="card  cursor-pointer card-sm card-hover-shadow card-header-borderless h-100 text-center">
                  <div className="card-header card-header-content-between border-0">
                    <span className="small">25-12-2024</span>

                    {/* <!-- Dropdown --> */}
                    <div class="dropdown">
                      <button
                        type="button"
                        class="card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreVert />
                      </button>

                      <div
                        class="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesGridDropdown1"
                        style={{ minWidth: "13rem" }}
                      >
                        <a class="dropdown-item" href="#">
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a class="dropdown-item" href="#">
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>

                  <div className="card-body">
                    <img
                      className="avatar avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-slides-icon.svg"
                      alt="Image Description"
                    />
                  </div>

                  <div className="card-body">
                    <h5 className="card-title text-dark">Livret de famille</h5>
                    <p className="small">Dr.Yassine Jaaidi</p>
                  </div>
                </div>
                {/* <!-- End Card --> */}
              </div>
              {/* <!-- End Col --> */}
            </div>
          </div>
        )}
        {activeTab === "list" && (
          <div
            className="tab-pane fade show active"
            id="list"
            role="tabpanel"
            aria-labelledby="list-tab"
            data-aos="fade-out"
            data-aos-delay="50"
            data-aos-duration="900"
          >
            {/* Content for list view */}
            <ul className="list-group">
              {/* <!-- List Item --> */}
              <li className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <img
                      className="avatar avatar-xs avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-docs-icon.svg"
                      alt="Image Description"
                    />
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col">
                    <h5 className="mb-0">
                      <a className="text-dark" href="#">
                        Liveret de famille
                      </a>
                    </h5>
                    <ul className="list-inline list-separator small text-body">
                      <li className="list-inline-item">Dr.Yassine Jaaidi</li>
                      <li className="list-inline-item">25-12-2024</li>
                    </ul>
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col-auto">
                    {/* <!-- Dropdown --> */}
                    <div className="dropdown">
                      <button
                        type="button"
                        class="p-3 card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreHoriz />
                      </button>

                      <div
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesListDropdown1"
                        style={{ minWidth: " 13rem" }}
                      >
                        <a className="dropdown-item" href="#">
                          <i className="bi-share dropdown-item-icon"></i>{" "}
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a className="dropdown-item" href="#">
                          <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>
                  {/* <!-- End Col --> */}
                </div>
                {/* <!-- End Row --> */}
              </li>
              {/* <!-- End List Item --> */}

              {/* <!-- List Item --> */}
              <li className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <img
                      className="avatar avatar-xs avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/pdf-icon.svg"
                      alt="Image Description"
                    />
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col">
                    <h5 className="mb-0">
                      <a className="text-dark" href="#">
                        Certificat médical
                      </a>
                    </h5>
                    <ul className="list-inline list-separator small text-body">
                      <li className="list-inline-item">Dr.Yassine Jaaidi</li>
                      <li className="list-inline-item">06-03-2022</li>
                    </ul>
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col-auto">
                    {/* <!-- Dropdown --> */}
                    <div className="dropdown">
                      <button
                        type="button"
                        class="p-3 card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreHoriz />
                      </button>

                      <div
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesListDropdown2"
                        style={{ minWidth: "13rem" }}
                      >
                        <a className="dropdown-item" href="#">
                          <i className="bi-share dropdown-item-icon"></i>{" "}
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a className="dropdown-item" href="#">
                          <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>
                  {/* <!-- End Col --> */}
                </div>
                {/* <!-- End Row --> */}
              </li>
              {/* <!-- End List Item --> */}

              {/* <!-- List Item --> */}
              <li className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <img
                      className="avatar avatar-xs avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-slides-icon.svg"
                      alt="Image Description"
                    />
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col">
                    <h5 className="mb-0">
                      <a className="text-dark" href="#">
                        WordPress theme presentation
                      </a>
                    </h5>
                    <ul className="list-inline list-separator small text-body">
                      <li className="list-inline-item">Dr.Yassine Jaaidio</li>
                      <li className="list-inline-item">3mb</li>
                    </ul>
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col-auto">
                    {/* <!-- Dropdown --> */}
                    <div className="dropdown">
                      <button
                        type="button"
                        class="p-3 card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreHoriz />
                      </button>

                      <div
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesListDropdown3"
                        style={{ minWidth: "13rem" }}
                      >
                        <a className="dropdown-item" href="#">
                          <i className="bi-share dropdown-item-icon"></i>{" "}
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a className="dropdown-item" href="#">
                          <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>
                  {/* <!-- End Col --> */}
                </div>
                {/* <!-- End Row --> */}
              </li>
              {/* <!-- End List Item --> */}

              {/* <!-- List Item --> */}
              <li className="list-group-item">
                <div className="row align-items-center">
                  <div className="col-auto">
                    <img
                      className="avatar avatar-xs avatar-4x3"
                      src="https://htmlstream.com/preview/front-dashboard-v2.1.1/assets/svg/brands/google-docs-icon.svg"
                      alt="Image Description"
                    />
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col">
                    <h5 className="mb-0">
                      <a className="text-dark" href="#">
                        Untitled
                      </a>
                    </h5>
                    <ul className="list-inline list-separator small text-body">
                      <li className="list-inline-item">Dr.Yassine Jaaidio</li>
                      <li className="list-inline-item">06-03-2022</li>
                    </ul>
                  </div>
                  {/* <!-- End Col --> */}

                  <div className="col-auto">
                    {/* <!-- Dropdown --> */}
                    <div className="dropdown">
                      <button
                        type="button"
                        class="p-3 card-dropdown-btn rounded-circle"
                        style={{ background: "none", border: "none" }}
                        id="filesGridDropdown1"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <MoreHoriz />
                      </button>

                      <div
                        className="dropdown-menu dropdown-menu-end"
                        aria-labelledby="filesListDropdown4"
                        style={{ minWidth: "13rem" }}
                      >
                        <a className="dropdown-item" href="#">
                          <i className="bi-share dropdown-item-icon"></i>{" "}
                          <FileOpenOutlined className="dropdown-item-icon" />
                          Ouvrir
                        </a>
                        <a className="dropdown-item" href="#">
                          <i className="bi-folder-plus dropdown-item-icon"></i>{" "}
                          <Download className="dropdown-item-icon" />{" "}
                          Télécharger
                        </a>
                      </div>
                    </div>
                    {/* <!-- End Dropdown --> */}
                  </div>
                  {/* <!-- End Col --> */}
                </div>
                {/* <!-- End Row --> */}
              </li>
              {/* <!-- End List Item --> */}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default MesDocuments;
